import { I18nStrings } from './index';

export const fr: I18nStrings = {
  cardTitle: (num: number, side: 'front' | 'back') =>
    `Carte ${num} (Côté ${side === 'front' ? 'recto' : 'verso'})`,
  insertFlipCard: 'Ajouter carte invertible',
  frontSide: 'Côté recto',
  backSide: 'Côté verso',
  flipToBack: 'Retourner au verso',
  flipToFront: 'Retourner au recto',
  clickToFlip: 'Cliquer pour retourner',
  addText: 'Ajouter du texte',
  addTextPlaceholder: 'Entrez votre texte...',
  addImage: 'Ajouter une image',
  insertImage: 'Insérer une image',
  uploadFile: 'Télécharger un fichier',
  urlPlaceholder: 'Entrez l\'URL de l\'image...',
  ok: 'OK',
  cancel: 'Annuler',
  copyCard: 'Copier la carte',
  deleteCard: 'Supprimer la carte',
  resetFace: 'Réinitialiser',
  dragHandle: 'Glisser pour réorganiser',
  or: 'ou'
};
